const SET_DEGREE_PAGE_TAB = 'SET_DEGREE_PAGE_TAB';
const SET_DEGREE_TAB_SECTIONS = 'SET_DEGREE_TAB_SECTIONS';

export { SET_DEGREE_PAGE_TAB, SET_DEGREE_TAB_SECTIONS };
